baseApp.directive('formInput', function() {
    return {
        templateUrl: '/public/directives/forminput.html',
        scope: {
            label: "@",
            path: "@",
            path2: "@",
            labelWidth: "@",
            vertical:"@",
            extraClass:"@",
            tooltipError: '<?',
            showEditPencil: '<?',
            inputId: "=?",
            hasScrollY: "<",
            isErrorOnNewLine: "<",
            tooltipDataType: "@",
            tooltipDataTitle: "@"
        },
        transclude: true,
        link: function($scope, elem, attr) {
            if(!$scope.labelWidth){
               $scope.labelWidth = 3;
            }

            if($scope.pattern){
                $scope.pattern = new RegExp($scope.pattern);
            }

            $scope.inputId = ($scope.inputId && $scope.inputId !== "") ? $scope.inputId : ("input_" + Math.random());

            angular.element(document).ready(function() {
                var $input = $(elem[0]).find('input, select, textarea');
                if ($input.length === 1 && $(elem[0]).length > 0 && !$input.attr('id')){
                    $input.attr('id', $scope.inputId);
                }
            });
        }
    };
});